var _defs, _rect, _rect2, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSendMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_18_13",
    "data-name": "Component 18 \\u2013 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 171,
    height: 171,
    viewBox: "0 0 171 171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7a30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0a13d"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_284",
    "data-name": "Rectangle 284",
    width: 141,
    height: 140,
    rx: 70,
    transform: "translate(15 15)",
    fill: "url(#linear-gradient)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_286",
    "data-name": "Rectangle 286",
    width: 171,
    height: 170,
    rx: 85,
    opacity: 0,
    fill: "url(#linear-gradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4372",
    "data-name": "Group 4372",
    transform: "translate(-74.88 182.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8864",
    "data-name": "Path 8864",
    d: "M159.968-117.626l2.275-2.277v15.091a9.437,9.437,0,0,0-7.083,9.178,9.507,9.507,0,0,0,9.5,9.5,9.518,9.518,0,0,0,9.495-9.5,9.441,9.441,0,0,0-7.083-9.178v-15.1l2.286,2.287a2.438,2.438,0,0,0,3.414-.007,2.439,2.439,0,0,0,0-3.41l-6.4-6.4a2.439,2.439,0,0,0-3.411,0l-6.4,6.4a2.419,2.419,0,0,0,0,3.414A2.479,2.479,0,0,0,159.968-117.626Zm-.411,21.992a5.1,5.1,0,0,1,5.1-5.1,5.125,5.125,0,0,1,5.1,5.1,5.106,5.106,0,0,1-5.1,5.1A5.1,5.1,0,0,1,159.557-95.634Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8865",
    "data-name": "Path 8865",
    d: "M178.764-115.81h-3.325a2.427,2.427,0,0,0-2.424,2.424,2.428,2.428,0,0,0,2.424,2.425h3.325a8.724,8.724,0,0,1,8.714,8.714v15.219a8.725,8.725,0,0,1-8.714,8.715H150.548a8.725,8.725,0,0,1-8.715-8.715v-15.219a8.724,8.724,0,0,1,8.715-8.714h3.324a2.428,2.428,0,0,0,2.425-2.425,2.427,2.427,0,0,0-2.425-2.424h-3.324a13.574,13.574,0,0,0-12.749,8.973,13.479,13.479,0,0,0-8.364,12.532v15.228A13.575,13.575,0,0,0,143-65.523h28.216a13.548,13.548,0,0,0,12.771-8.994,13.5,13.5,0,0,0,8.341-12.511v-15.219A13.578,13.578,0,0,0,178.764-115.81ZM150.548-73.465h27.324a8.718,8.718,0,0,1-6.658,3.093H143a8.719,8.719,0,0,1-8.715-8.705V-94.305a8.655,8.655,0,0,1,2.7-6.318v13.6A13.579,13.579,0,0,0,150.548-73.465Z",
    fill: "#fff"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMoney);
export default __webpack_public_path__ + "static/media/sendMoney.9f91aaa916d523c37656398458326884.svg";
export { ForwardRef as ReactComponent };